import React, { FormEvent } from 'react';
import { JRCButton } from '../JRCButton/JRCButton';
import { JRCModalBody, JRCModalClose, JRCModalFooter, JRCModalHeader } from './JRCModal.styles';
import { JRCIconButton } from '../JRCIconButton/JRCIconButton';
import { JRCModalButtonType, JRCModalContentBase, ModalOptions, ModalTitle } from './JRCModalContent';
import styled from 'styled-components';

export type JRCModalContentFormProps = JRCModalContentBase & {
    buttons?: JRCModalFormButtonType[];
    onSubmit: (e: FormEvent) => Promise<void>;
    loading?: boolean;
};

export interface JRCModalFormButtonType extends JRCModalButtonType {
    isSubmit?: boolean;
}

const Form = styled.form<{ overflow?: 'hidden' | 'visible' | 'scroll' }>`
    display: flex;
    flex-direction: column;
    flex: 1;
    ${({ overflow }) => (overflow ? `overflow: ${overflow === 'scroll' ? 'auto' : overflow};` : '')}
`;

export const JRCModalContentForm = ({
    onSubmit,
    children,
    loading,
    title,
    onClickIconClose,
    options,
    buttons,
    overflow,
}: JRCModalContentFormProps) => {
    return (
        <Form aria-disabled={loading} onSubmit={onSubmit} overflow={overflow}>
            {(title || onClickIconClose) && (
                <JRCModalHeader className={'modal-header'} modalOverflow="scroll">
                    <ModalTitle>{title}</ModalTitle>
                    <ModalOptions>{options}</ModalOptions>
                    {onClickIconClose && (
                        <JRCModalClose>
                            <JRCIconButton icon="icon-times" onClick={onClickIconClose} />
                        </JRCModalClose>
                    )}
                </JRCModalHeader>
            )}
            <JRCModalBody className="modal-content" modalOverflow={overflow ?? 'scroll'}>
                {children}
            </JRCModalBody>
            {buttons && (
                <JRCModalFooter modalOverflow="scroll">
                    {buttons.map((button: JRCModalFormButtonType, index: number) => (
                        <JRCButton
                            key={index}
                            color={button.color}
                            variant={button.variant}
                            onClick={button.isSubmit ? undefined : button.clickHandler}
                            dataCy={button.dataCy}
                            type={button.isSubmit ? 'submit' : undefined}
                            disabled={(button.isSubmit && loading) || button.disabled}
                            loader={(button.isSubmit && loading) || button.loading}>
                            {button.children}
                        </JRCButton>
                    ))}
                </JRCModalFooter>
            )}
        </Form>
    );
};
